/** @jsxImportSource @emotion/react */
import { useRef, useEffect } from 'react'

import { Order } from 'store/types'
import { ReportListing } from 'components/organisms/reports/ReportListing'

interface IProps {
  order: Order
  refetchOrder: () => void
}

const ReportTab = ({ order, refetchOrder }: IProps) => {
  // POX/COX: the report went to the referring provider, but the DME copy is held until
  // the signed AOB is uploaded and the lab verifies it (reportsHeldForAob comes stripped
  // of any report data from the backend, so there is nothing to list anyway).
  const reportsHeld = (order as { reportsHeldForAob?: 'NO_REPORT_YET' | 'REPORT_READY' } | undefined)?.reportsHeldForAob

  const reportQueued = order?.reports && Object.values(order?.reports).some((v) => v === 'QUEUED')
  const intervalRef = useRef()

  useEffect(() => {
    if (reportQueued && !intervalRef.current) {
      intervalRef.current = setInterval(refetchOrder, 2000)
    } else {
      clearInterval(intervalRef?.current?.cancel)
    }

    return () => clearInterval(intervalRef.current)
  }, [reportQueued])

  if (reportsHeld) {
    return (
      <div className="alert alert-warning m-3">
        <i className="fas fa-lock mr-2" />
        {reportsHeld === 'REPORT_READY'
          ? 'The report has been completed and faxed to the referring provider. It will become available here once the signed AOB is uploaded and verified.'
          : 'Report results will be available here only after the signed AOB is uploaded and verified.'}
      </div>
    )
  }

  return <ReportListing order={order} />
}

export default ReportTab
